"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kebabToCamelConverter = void 0;
const kebabToCamelConverter = (string) => string.replace(/-./g, (x) => x.toUpperCase()[1]);
exports.kebabToCamelConverter = kebabToCamelConverter;
//# sourceMappingURL=kebabToCamel.js.map